import React, { useState, useEffect } from "react";
import { Navbar, Nav, Button } from "react-bootstrap";
import { Link } from "react-scroll";
import ThemeLogo from "../../assets/Images/BrandLogo/LogoBianco.png";
import BlackThemeLogo from "../../assets/Images/BrandLogo/LogoColorato.png";
import { useNavigate, useLocation } from "react-router-dom"; // Utilizzo di useLocation
import { logoutMicrosoft } from "../../Auth/AuthMicrosoft/authMicrosoft";
import { useMsal } from "@azure/msal-react";
import { logout } from "../../Auth/authUtils";

/** Destinazione del pulsante « Accedi » (fuori da /service): URL assoluto o percorso B2C. Impostare in .env: REACT_APP_ACCESO_REDIRECT_URL */
const ACCESO_REDIRECT_URL =
  process.env.REACT_APP_ACCESO_REDIRECT_URL || "https://shop.italycashpuglia.it/";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollClass, setScrollClass] = useState("");
  const navigate = useNavigate();
  const location = useLocation(); // Recupera il percorso attuale
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const [authMethod, setAuthMethod] = useState(
    localStorage.getItem("authMethod")
  );
  const { instance } = useMsal();

  // Monitora i cambiamenti esterni (altre schede)
  useEffect(() => {
    const handleStorageChange = () => {
      setAuthToken(localStorage.getItem("authToken"));
      setAuthMethod(localStorage.getItem("authMethod"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  // Monitora i cambiamenti locali
  useEffect(() => {
    setAuthToken(localStorage.getItem("authToken"));
    setAuthMethod(localStorage.getItem("authMethod"));
  }, [localStorage.getItem("authToken")]);

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector("nav");
      const closeNav = document.getElementById("close-nav");
      
      if (window.scrollY > 20) {
        nav?.classList.add("inverted");
        closeNav?.classList.add("inverted");
        setScrollClass("scrolled");
      } else {
        nav?.classList.remove("inverted");
        closeNav?.classList.remove("inverted");
        setScrollClass("");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleAuth = (e) => {
    e.preventDefault();
    // Logout solo su /service - mai su home o altre pagine
    if (location.pathname === "/service" && authToken) {
      logout(authMethod, instance, navigate);
      setAuthToken(null);
      setAuthMethod(null);
    } else {
      // Fuori da /service: area riservata / shop (configurabile via .env)
      window.location.href = ACCESO_REDIRECT_URL;
    }
  };

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      // Se siamo già sulla pagina principale, ricarica la pagina
      window.location.reload();
    } else {
      // Altrimenti, naviga verso la pagina principale
      navigate("/");
    }
  };

  const toggleMenu = () => {
    const overlay = document.getElementById("myOverlay");
    const menu = document.getElementById("stamenu");
    setIsMenuOpen(!isMenuOpen);
    overlay.style.display = isMenuOpen ? "none" : "block";
    menu.classList.toggle("active", !isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.getElementById("myOverlay").style.display = "none";
    document.getElementById("stamenu").classList.remove("active");
  };

  return (
    <div className={scrollClass}>
      <div className="header">
        <div className="sticky-top" id="stamenu">
          <Navbar expand="lg" collapseOnSelect>
            <div className="container">
              <div className="inner-header">
                {location.pathname !== "/service" ? ( // Utilizzo di location.pathname
                  <Navbar.Brand onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
                    <img
                      src={ThemeLogo}
                      alt="logo"
                      className="img-fluid mx-auto WLogo"
                    />
                    <img
                      src={BlackThemeLogo}
                      alt="logo"
                      className="img-fluid mx-auto BLogo"
                    />
                  </Navbar.Brand>
                ) : (
                  <Navbar.Brand onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
                    <img
                      src={ThemeLogo}
                      alt="logo"
                      className="img-fluid mx-auto WLogo"
                    />
                    <img
                      src={BlackThemeLogo}
                      alt="logo"
                      className="img-fluid mx-auto BLogo"
                    />
                  </Navbar.Brand>
                )}

                <Button
                  className="btn-navbar navbar-toggle"
                  onClick={toggleMenu}
                  aria-label="Toggle navigation"
                >
                  <i className="fa fa-bars" aria-hidden="true"></i>
                </Button>

                <div id="mySidenav" className="sidenav menu-vertical">
                  <div className="close-nav hidden-md hidden-lg hidden-xl" id="close-nav">
                    <span style={{ color: '#ffffff' }}>Menu</span>
                    <Button className="closebtn pull-right" onClick={closeMenu} style={{ color: '#ffffff' }}>
                      <i className="fa fa-times" aria-hidden="true"></i>
                    </Button>
                  </div>
                  {location.pathname !== "/signin" &&
                    location.pathname !== "/service" && (
                      <Nav className="justify-content-center">
                        <Nav.Link
                          as={Link}
                          to="chisiamo"
                          onClick={closeMenu}
                          offset={-150}
                          duration={1000}
                          style={{ cursor: "pointer" }} // Aggiunta del cursore pointer
                        >
                          Chi siamo
                        </Nav.Link>
                        <Nav.Link
                          as={Link}
                          to="diventacliente"
                          onClick={closeMenu}
                          offset={-75}
                          duration={1000}
                          style={{ cursor: "pointer" }} // Aggiunta del cursore pointer
                        >
                          Diventa cliente
                        </Nav.Link>
                        <Nav.Link
                          as={Link}
                          to="cashcarry"
                          onClick={closeMenu}
                          offset={-150}
                          duration={1000}
                          style={{ cursor: "pointer" }} // Aggiunta del cursore pointer
                        >
                          Cash & Carry
                        </Nav.Link>
                        <Nav.Link
                          as={Link}
                          to="assortimento"
                          onClick={closeMenu}
                          offset={-150}
                          duration={1000}
                          style={{ cursor: "pointer" }} // Aggiunta del cursore pointer
                        >
                          Assortimento
                        </Nav.Link>
                        <Nav.Link
                          as={Link}
                          to="marchi"
                          onClick={closeMenu}
                          offset={-175}
                          duration={1000}
                          style={{ cursor: "pointer" }} // Aggiunta del cursore pointer
                        >
                          Marchi
                        </Nav.Link>
                        <Nav.Link
                          as={Link}
                          to="iscriviti"
                          onClick={closeMenu}
                          offset={-75}
                          duration={1000}
                          style={{ cursor: "pointer" }} // Aggiunta del cursore pointer
                        >
                          Iscriviti
                        </Nav.Link>
                      </Nav>
                    )}
                </div>

                {location.pathname === "/signin" ? (
  <button className="white-btn button" onClick={(e) => { 
    e.preventDefault(); 
    navigate("/", { replace: true });
  }}>
    <a href="/">Indietro</a>
  </button>
) : location.pathname === "/service" ? (
  <button className="white-btn button" onClick={handleAuth}>
    <a href="#">{authToken ? "Esci" : "Accedi"}</a>
  </button>
) : (
  <button className="white-btn button" onClick={handleAuth}>
    <a href="#">Accedi</a>
  </button>
)}
              </div>
            </div>
          </Navbar>
        </div>
      </div>
      <div id="myOverlay" style={{ display: "none" }} onClick={closeMenu} />
    </div>
  );
};

export default Header;
